"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createNotificationEmails = exports.fetchBlogs = exports.deleteBlog = exports.updateBlog = exports.createBlog = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _reduxObservable = require("redux-observable");

var _API = _interopRequireDefault(require("./API"));

var createBlog = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createBlog,
  initiatingActionType: _actions.BlogActionTypes.CREATE_BLOG,
  requestStatusSelector: _selectors.getCreateBlogRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateBlog
}));
exports.createBlog = createBlog;
var updateBlog = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateBlog,
  initiatingActionType: _actions.BlogActionTypes.UPDATE_BLOG,
  requestStatusSelector: _selectors.getUpdateBlogRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateBlog
}));
exports.updateBlog = updateBlog;
var deleteBlog = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteBlog,
  initiatingActionType: _actions.BlogActionTypes.DELETE_BLOG,
  requestStatusSelector: _selectors.getDeleteBlogRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.DeleteBlog
}));
exports.deleteBlog = deleteBlog;
var fetchBlogs = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getBlogs,
  initiatingActionType: _actions.BlogActionTypes.LOAD_BLOGS,
  requestStatusSelector: _selectors.getFetchBlogsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchBlogs
}));
exports.fetchBlogs = fetchBlogs;
var createNotificationEmails = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createNotificationEmails,
  initiatingActionType: _actions.BlogActionTypes.CREATE_BLOG_NOTIFICATION_EMAILS,
  requestStatusSelector: _selectors.getCreateBlogNotificationEmailsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateBlogNotificationEmails
}));
exports.createNotificationEmails = createNotificationEmails;

var _default = (0, _reduxObservable.combineEpics)(fetchBlogs, createBlog, updateBlog, deleteBlog, createNotificationEmails);

exports.default = _default;